/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from "react";
import { useParams,useNavigate} from 'react-router-dom';
import Spreadsheet from "react-spreadsheet";
import { APIEndpoint } from "../../../utils/axios";
import { updateButtonTxtStatus, validateCellAndGetData } from "../../../utils/commonFunctions";
import TooltipExcelsheet from "../../../common/TooltipExcelsheet";
import closeIcon from "../../../images/icons/Icon2.png"
import { AlertModal,SpreadSheetActions } from "../../../common";
import * as ReactDOM from 'react-dom';
import { useTranslation } from "react-i18next";
import { DEFAULT_SHEET_ROWS, ErrorFields } from "../../../utils/configs";

let spreadSheetErrTimout;

const iIndexes = {
    ITEM_CODE: 0,
    ITEM_NAME: 1,
    ITEM_UNIT: 2,
    ITEM_REQ_QTY: 3,
    ITEM_RECI_QTY: 4,
    ITEM_QTY: 5,
    ITEM_REMARKS: 6
};

const grnSheetLabels = ['Item Code', 'Item Name', 'Unit', 'Requested Quantity', 'Received Quantity', 'Quantity', 'Remarks'];

/**
 * Automatically creating rows
 */
// const initialData = createEmptyMatrix(10, grnSheetLabels.length);
/**
 * Manually creating rows
 */
const singleRowAdd=[
    {
        "id": "itemCode",
        "value": "",
        "className": "cellClass cellClass_2_0",
        "width": "200px",
        "showPopup": true
    },
    {
        "id": "itemName",
        "value": "",
        "className": "cellClass cellClass_2_1",
        "width": "200px",
        "showPopup": true
    },
    {
        "id": "unit",
        "value": "NOS",
        "className": "cellClass1 fixedfields",
        "width": "400px",
        "readOnly": true,
        "required": true
    },
    {
        "id": "requestedQty",
        "value": "",
        "className": "cellClass cellClass_2_3 fixedfields",
        "width": "200px",
        "readOnly": true,
        "required": true
    },
    {
        "id": "receivedQty",
        "value": "",
        "className": "cellClass cellClass_2_4 fixedfields",
        "width": "200px",
        "readOnly": true,
        "required": true
    },
    {
        "id": "quantity",
        "value": "",
        "className": "cellClass cellClass_2_5",
        "width": "200px",
        "type": "number",
        "readOnly": false,
        "required": true
    },
    {
        "id": "remarks",
        "value": "",
        "className": "cellClass1",
        "width": "200px",
        "readOnly": false,
        "required": false
    }
]


export const GRNForPurchaseOrderCreate = (props) => {
    const [initialData] = useState(() => createEmptySheetRows(DEFAULT_SHEET_ROWS, []));
    const urlParams = useParams();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { warehouseId, purchaseOrderId, invoiceInputs } = urlParams;
    const invoiceObj = JSON.parse(invoiceInputs);
    const [count, setCount] = useState(1);
    const [itemData, setItemData] = useState([]);
    const [cellChange,setCellChange]=useState({});
    const [sheetTitle, setSheetTitle] = useState("");
    const [state, setState] = useState({ isInvalidAccess: false, message: '' });
    const [grnSheetData, setGrnSheetData] = useState( initialData);
    const [spreadsheetErrors, setSpreadsheetErrors] = useState([]);
    const modelStyle = { maxWidth: '50%', margin: 'auto 10% 100% 10%' };
    const [activeCell, setActiveCell] = useState([]);

    function createEmptySheetRows (noOfRows = DEFAULT_SHEET_ROWS,data){
     let len = data ? data.length:0
    const rows=[];
    for( var i=0; i < noOfRows; i++) {
        rows.push([
            {
                id: 'itemCode',
                value: '',
                className: 'cellClass cellClass_' + len + '_' + iIndexes.ITEM_CODE,
                width: '200px',
                showPopup: true
            },
            {
                id: 'itemName',
                value: '',
                className: 'cellClass cellClass_' + len + '_' + iIndexes.ITEM_NAME,
                width: '200px',
                showPopup: true
            },
            {
                id: 'unit',
                value: '',
                className: 'cellClass1 fixedfields',
                width: '400px',
                readOnly: true,
                required:true
            },
            {
                id: 'requestedQty',
                value: '',
                className: 'cellClass cellClass_' + len + '_' + iIndexes.ITEM_REQ_QTY + ' fixedfields' ,
                width: '200px',
                readOnly: true,
                required:true

            },
            {
                id: 'receivedQty',
                value: '',
                className: 'cellClass cellClass_' + len + '_' + iIndexes.ITEM_RECI_QTY+ ' fixedfields',
                width: '200px',
                readOnly: true,
                required:true
            },
            {
                id: 'quantity',
                value: '',
                className: 'cellClass cellClass_' + len + '_' + iIndexes.ITEM_QTY,
                width: '200px',
                type:'number',
                readOnly:false,
                required:true
            },
            {
                id: 'remarks',
                value: '',
                className: 'cellClass1',
                width: '200px',
                readOnly:false,
                required:false
            }
        ]);
        len++
    }
    return rows;

    }

    const targetEltCodes = document.getElementsByClassName("cellSelectionBlockItemCodes")[0];
    const targetEltNames = document.getElementsByClassName("cellSelectionBlockItemNames")[0];
const extraProps={errorDetails:{err1:ErrorFields[3].label,err2:ErrorFields[1].message},page:'grnPoCreate',errorClasses:['errorCellGRNrevQty','errorCellGRNrev']}
    const goBack = () => {
        localStorage.removeItem('grnList');
        navigate(-1); //navigates back to the previous page
    };
    useEffect(()=>{
        localStorage.removeItem('grnList');
        getVendorDetails();
    },[])


    const getVendorDetails = async() => {
        try {
            const resVendorId = await APIEndpoint.get(`purchaseOrders/findById/${urlParams.purchaseOrderId}`)
              if (resVendorId && resVendorId?.data) {
                const payload={
                    "purchaseOrderId":urlParams.id,
                    "warehouseId":resVendorId?.data.warehouseId,
                    "vendorId": resVendorId?.data?.vendorId,

                }
                try {
                    const [resVendor,resItems] = await Promise.all([
                        APIEndpoint.post('warehouses/vendorItems',payload),
                        APIEndpoint.get('items/enumerate'),
                      ]);
                      if (resVendor.success && resVendor.items.length && resItems.success && resItems.items.length) {
                        setSheetTitle(resVendorId?.data?.code)
                        setEditTransferItemsToSheet(resVendorId?.data?.items);
                        setItemData( resItems.items.filter(_=>resVendor.items.find(rsv=>rsv?.itemId===_?.itemId)))
                    }
                } catch (error) {
                    console.log('Invalid page access!, Letter of Intent ID not found.', error.message);

                    setState({ ...state, isInvalidAccess: true,
                        message: "Invalid page access!, GRN ID not found, On click OK, you will be redirected to  Purchase Order page." });
                }
            }
        } catch (error) {
            console.log('Invalid page access!,  GRN ID not found.', error.message);

            setState({ ...state, isInvalidAccess: true,
                message: "Invalid page access!,  GRN ID not found, On click OK, you will be redirected to Purchase Order page." });
        }
    };



    //Api call for fetch purchase order items

    const addRowsToSheet = (e) => {
        const newRows = createEmptySheetRows(10,grnSheetData);
        setGrnSheetData([...grnSheetData,...newRows])
    };
 
      useEffect(() => {
        if (!Object.keys(cellChange).length) return;

        const timeout = setTimeout(() => {
            setGrnSheetData((prevData) => {
                const updatedSheetData = prevData.map((row, rowIndex) =>
                    row.map((cell, cellIndex) => {
                        if (
                            activeCell.column === 5 &&
                            cell.className.includes(`${activeCell.row}_${activeCell.column}`)
                        ) {
                            if (cell.className.includes("errorCellGRNrev")) {
                                const classNameId = cell.className
                                    .split(" ")
                                    .slice(1)
                                    .join(" ")
                                    .toString();
                                return { ...cell, className: classNameId };
                            }
                        }
                        return { ...cell };
                    })
                );

                return [...updatedSheetData];
            });

            const errLabel = document.querySelectorAll('.sheetErrDiv');
            if (errLabel.length > 0) {
                errLabel.forEach((el) => el.remove());
            }

            setCellChange({});
        }, 100);

        return () => clearTimeout(timeout);

    }, [cellChange, activeCell]);


    function onChangeSheet(data){
        setGrnSheetData(data);
         setSpreadsheetErrors([]);
        const initialSheetData = JSON.parse(localStorage.getItem("grnList"));
        let jsonSpreadsheetData = JSON.stringify( data );
        let SpreadsheetData = JSON.parse(jsonSpreadsheetData);
        const updatedSpreadsheetData = SpreadsheetData.map( (sheetRow, i) => {
            if (i === activeCell.row) {
                sheetRow=sheetRow.map((sheetData,celInd)=>{
            if(sheetData && sheetData.id ==='receivedQty'){
                if(!isNaN(sheetRow[iIndexes.ITEM_QTY]?.value)){
                    sheetData.value = Number(initialSheetData[activeCell.row][4].value)+ Number(sheetRow[iIndexes.ITEM_QTY]?.value);
            if(sheetData.value > Number(initialSheetData[activeCell.row][3].value)){
                return {...sheetData,className:`errorCellGRNrevQty cellClass ${sheetData.className} fixedfields`}
                }
                else{
                    return {...sheetData,className:`cellClass1 fixedfields`}
                }

                }else{
                            return {...sheetData}
                        }

                        }
                        if(sheetData && sheetData.id ==='quantity'){
                            if(isNaN(sheetRow[iIndexes.ITEM_QTY]?.value)){
                                return {...sheetData,value:''}
                            }


                                    }

                    return sheetData;
                    }



                    )
            }



            return sheetRow;
        } );
        setGrnSheetData([...updatedSpreadsheetData])
    }


    // save create grn

    const saveSheetData = (e) => {
        clearTimeout(spreadSheetErrTimout)
        // updateButtonTxtStatus(true, e, 'Saving...', true);
        const postItems = [];
        setSpreadsheetErrors([]);
        let inSheetData = [ ...grnSheetData ];
       const saveGrn= inSheetData.map( (cellRow, idx) => {
        if(!cellRow.some((cell) => cell.id === "itemCode" && cell.value === "")){
       const itemCode = validateCellAndGetData(cellRow[iIndexes.ITEM_CODE]);
            const itemName = validateCellAndGetData(cellRow[iIndexes.ITEM_NAME]);
            const unit = validateCellAndGetData(cellRow[iIndexes.ITEM_UNIT]);
            const requestedQty = Number(validateCellAndGetData(cellRow[iIndexes.ITEM_REQ_QTY]));
            const receivedQty = Number(validateCellAndGetData(cellRow[iIndexes.ITEM_RECI_QTY]));
            const quantity = validateCellAndGetData(cellRow[iIndexes.ITEM_QTY]);
            const remarks = validateCellAndGetData(cellRow[iIndexes.ITEM_REMARKS]);

            if (itemCode && itemName && unit && (typeof requestedQty  === 'number' && requestedQty >= 0) && (typeof receivedQty==='number' && receivedQty>=0) && (typeof quantity==='number' && quantity>=0)) {
                postItems.push({
                    itemCode,
                    itemName,
                    unit,
                    requestedQuantity: parseInt(requestedQty),
                    receivedQuantity: parseInt(receivedQty),
                    quantity: parseInt(quantity),
                    remarks
                });
            }
            else if (isNaN(quantity)) {
                cellRow = cellRow.map((cell,celInd)=>{
                    if ( cell && cell?.required === true && cell?.readOnly === false ) {
                        if(cell.id === 'quantity' && (!cell.value || cell.value === undefined) && !cell.className.includes('errorCellGRNrev')){
                            return {...cell,className:`errorCellGRNrev cellClass ${cell.className}`}
                        }

                    }
                    return cell;
                    }

                    )
                setSpreadsheetErrors([ { message: 'Please fix the errors and try again.' } ]);
            }
        }

            return cellRow;
        });


         setGrnSheetData(saveGrn);

        if (postItems.length === 0) {
            // show global alert message
            // setSpreadsheetErrors([ ...spreadsheetErrors, { message: 'We did not find anything to save!' } ]);
            return false;
        }

        if ( !postItems.length ) {
            return false;
        }

        const data = {
            id: purchaseOrderId,
            warehouseId,
            grnId: null,
            invoiceNo: (invoiceObj.invoiceNo || ''),
            invoiceDate: (invoiceObj.invoiceDate || ''),
            items: postItems
        }
        // GET /api/purchaseOrders/findById/{poid}
        // GET /api/purchaseOrders/grns/findById/' + $scope.grnId

        APIEndpoint.post('purchaseOrders/saveGrn', data)
        .then( apiResp => {
            /**
             * Update success response
             */
            updateButtonTxtStatus(true, e, 'Redirecting...', true, { defaultButtonText: 'Save'} );
             setGrnSheetData(initialData);
            setSpreadsheetErrors([ ...spreadsheetErrors, { message: apiResp.msg || 'Successfully created GRN.' } ]);
            setTimeout( () => {
                goBack();
            }, 1500);
        })
        .catch( (error) => {
            // api response error handling
            const apiData = JSON.parse(error.message);
            setSpreadsheetErrors([]);
            ReactDOM.flushSync( () => {
                if ( apiData?.data.errors ) {
                    const errorMsg = apiData.data.errors.message;
                    const errorArr = apiData.data.errors.errors[0].message;
                    setSpreadsheetErrors([ ...spreadsheetErrors, { message: errorMsg, error: 1 },...errorArr ]);
                    
                }
                else if (apiData.msg) {
                    setSpreadsheetErrors([ ...spreadsheetErrors, { message: apiData.msg, error: 1 } ]);

                }
                else {
                    setSpreadsheetErrors([ ...spreadsheetErrors, { message: 'Something went wrong, please try again later!', error: 1 } ]);

                }
            });
            spreadSheetErrTimout=setTimeout(() => {
                setSpreadsheetErrors([])
            }, 2500);
        });

    };

     // create popup itemlist

       const showItemListPopup = (eltPosition, activeCellIn) => {
        if (activeCellIn.column === iIndexes.ITEM_CODE) {
            if (targetEltCodes) {
                targetEltCodes.style.display = 'block';
                targetEltCodes.style.top = ( eltPosition.height + eltPosition.top + 2 ).toFixed() + 'px';
                targetEltCodes.style.left = eltPosition.left.toFixed() + 'px';
            }
        } else if (activeCellIn.column === iIndexes.ITEM_NAME) {
            if (targetEltNames) {
                targetEltNames.style.display = 'block';
                targetEltNames.style.top = ( eltPosition.height + eltPosition.top + 2 ).toFixed() + 'px';
                targetEltNames.style.left = eltPosition.left.toFixed() + 'px';
            }
        }
    }
     const hidePopupList = () =>{
        // if (activeCell.column === iIndexes.ITEM_CODE) {
            if (targetEltCodes) {
                targetEltCodes.style.display = 'none';
            }
        // } else if (activeCell.column === iIndexes.ITEM_NAME) {
            if (targetEltNames) {
                targetEltNames.style.display = 'none';
            }
        // } else if (activeCell.column === iIndexes.ITEM_NAME) {

        // }
    }


    const handleActiveCellChange = (activeCell) => {
        hidePopupList();
        setActiveCell(activeCell);
        setSpreadsheetErrors([]);

    }

    const onClickPopupListItem = (e, row) => {
        setPurchaseorderItemToSheet(row);
    }


        const setEditTransferItemsToSheet = (grnItems) => {
            let jsonSpreadsheetData = JSON.stringify( grnSheetData );
            let updatedSpreadsheetData = JSON.parse(jsonSpreadsheetData);

            grnItems.map( (item, i) => {
                updatedSpreadsheetData[i][iIndexes.ITEM_CODE].value = item.itemCode;
                updatedSpreadsheetData[i][iIndexes.ITEM_NAME].value = item.itemName;
                updatedSpreadsheetData[i][iIndexes.ITEM_UNIT].value = item.unit;
                updatedSpreadsheetData[i][iIndexes.ITEM_REQ_QTY].value = item.requestedQuantity;
                updatedSpreadsheetData[i][iIndexes.ITEM_RECI_QTY].value = item.receivedQuantity;
                updatedSpreadsheetData[i][iIndexes.ITEM_REMARKS].value = item.remarks;

                return item;
            });


            ReactDOM.flushSync( () => {
                setGrnSheetData( [ ...updatedSpreadsheetData ]);

            });
            localStorage.setItem("grnList",JSON.stringify([ ...updatedSpreadsheetData ]))
        };

    const setPurchaseorderItemToSheet = (item) => {

        if (Object.keys(item).length === 0) {
            return 0;
        }
        if (Object.keys(item).length === 0) {
            return 0;
        }

        let jsonSpreadsheetData = JSON.stringify( grnSheetData);
        let updatedSpreadsheetData = JSON.parse(jsonSpreadsheetData);

        updatedSpreadsheetData.map( (sheetRow, i) => {
            if (i === activeCell.row) {
                sheetRow[iIndexes.ITEM_CODE].value = item.itemCode;
                sheetRow[iIndexes.ITEM_NAME].value = item.itemName;
                sheetRow[iIndexes.ITEM_UNIT].value = item.unit;
                sheetRow[iIndexes.ITEM_REQ_QTY].value = item.requestedQuantity;
                sheetRow[iIndexes.ITEM_RECI_QTY].value = item.receivedQuantity;
                sheetRow[iIndexes.ITEM_REMARKS].value = item.remarks;

            }
            return sheetRow;
        });
        ReactDOM.flushSync( () => {
            setGrnSheetData( [ ...updatedSpreadsheetData ]);
        });

        setActiveCell({});
        hideItemListPopup();
    }

    const hideItemListPopup = () =>{
        // if (activeCell.column === iIndexes.ITEM_CODE) {
            if (targetEltCodes) {
                targetEltCodes.style.display = 'none';
            }
        // } else if (activeCell.column === iIndexes.ITEM_NAME) {
            if (targetEltNames) {
                targetEltNames.style.display = 'none';
            }
        // }
    }

    const onCellCommitHandle = (prevCell, nextCell, coordinates) => {
        setCellChange(nextCell);

    }

    const grnPODetailsErrorComp = (ExtraComponent, extraProps) => {

        return (props) => <ExtraComponent {...props} {...extraProps} />;
      };
        const spredSheetControls={
        count,
        setCount,
        sheetData:grnSheetData,
        setSheetData:setGrnSheetData,
        saveSheetData,
        createEmptySheetRows,
        hideItemListPopup,
        singleRowAdd,
        activeCell,
        t
        }
    return (
        <>
            <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
                <div className="header m-2 mb-2 flexRow justifyContentSpaceBetween" >
                <SpreadSheetActions {...spredSheetControls}/>
                {spreadsheetErrors.length >= 1? <div className={`padding4 margTop9-5 alert alert-${spreadsheetErrors[0].message.includes('fully') ? 'success' : 'danger'}`}>
                {spreadsheetErrors.length >= 1 ? spreadsheetErrors[0]?.message : null}
                </div>:null}
                <button onClick={goBack}  >
                <img src={closeIcon} alt="close" data-icon='close'/>
                </button>
                </div>
                <div className="se-titlebar">
               {<span>{urlParams?`GRN for purchase order -${sheetTitle}`:null}</span>}
                   </div>
                   
                <div className="sheet-container sm-scrollbar reconCreate">
                     <Spreadsheet data={grnSheetData}
                        onChange={onChangeSheet}
                        columnLabels={grnSheetLabels}
                        darkMode={true}
                        DataViewer={grnPODetailsErrorComp(TooltipExcelsheet,extraProps)}
                        onActivate={handleActiveCellChange}
                        onCellCommit={onCellCommitHandle}

                    />


                    <div className = "cellSelectionBlockItemCodes sm-scrollbar">
                       <ul>
                        {
                            itemData.map((d,i)=>{
                                return <li key={i} onClick={(e) => onClickPopupListItem(e, d) }>{d.itemCode}</li>
                            })
                        }
                       </ul>
                    </div>
                    <div className = "cellSelectionBlockItemNames sm-scrollbar">
                       <ul>
                        {
                            itemData.map((d,i)=>{
                                return <li key={i} onClick={(e) => onClickPopupListItem(e, d) }>{d.itemName}</li>
                            })
                        }
                       </ul>
                    </div>
                </div>
                <div className="flexRow alignItemsCenter margTop8">
                        <button onClick={ (e) => {e.stopPropagation();addRowsToSheet(e) }}
                            className="add-item-button" title={ t('spreadsheet.addmoreRows') }>{ t('buttons.addRows') }</button>
                    </div>

                {
                    Boolean(state.isInvalidAccess) && (
                    <AlertModal
                        title={'Alert: Invalid Access'}
                        customModalStyle={ modelStyle }
                        description={ state.message }
                        onContinue={goBack}
                        onClose={goBack}
                    />
                    )
                }
            </div>
        </>
    );
}